import i18n from '@assets/i18n/index';
import PtMessageBox from '@ui/message-box';
import { Profile } from '@models/profile/profileList';
import { Product } from '@models/profile/useCurrentProfile';
import useActiveProduct from '@master/hooks/service/useActiveProduct/useActiveProduct';
import { useProfileInfo } from '@models/profile/useCurrentProfile';

export default function useShowAuthDialog() {
    const { activeConfirm } = useActiveProduct();

    const checkAuth = function (
        product: Product,
        profile: Profile,
        callBack?: any,
        noAuthCallBack?: any
    ) {
        if (!product?.key) return;
        const hasRole = profile[product.roleKey];
        const active = profile[product.activeKey];
        if (active) {
            if (hasRole) {
                callBack?.();
            } else {
                if (noAuthCallBack) {
                    noAuthCallBack();
                } else {
                    PtMessageBox({
                        title: i18n?.global?.t('common.change_profile_permission_title', {
                            product: product.name
                        }),
                        confirmButtonText: i18n?.global?.t('form.button.close'),
                        showClose: true,
                        message:
                            i18n?.global?.t('common.change_profile_permission_01', {
                                product: product.name
                            }) +
                            profile.name +
                            i18n?.global?.t('common.change_profile_permission_02') +
                            profile.ownerEmail +
                            i18n?.global?.t('common.change_profile_permission_03')
                    });
                }
            }
        } else {
            activeConfirm(profile.sid, product.key);
        }
    };
    return { checkAuth };
}

export function useRoleDialog(): boolean {
    const { profileInfo, profilePtxUserRoleIsReadOnly } = useProfileInfo();

    if (profilePtxUserRoleIsReadOnly.value) {
        PtMessageBox({
            title: i18n?.global?.t('experience.message.no_create_access_title'),
            confirmButtonText: i18n?.global?.t('form.button.close'),
            showCancelButton: false,
            showConfirmButton: true,
            showClose: true,
            message: i18n?.global?.t('experience.message.no_create_access_tips', {
                owner: profileInfo.value?.ownerEmail
            })
        });
        return false;
    }
    return true;
}
